import React from 'react';
import { connect } from 'react-redux';
import Moment from '../../../components/utils/Moment';
import PatientAlerts from './PatientAlerts';
import { requestVisitNote } from '../../../store/visit-notes/VisitNotesActions';
import { getAlerts } from '../utils/alerts';

class VisitNoteCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = { info: {}, remoteInfo: null };
  }

  componentWillMount() {
    const { id, getNote, info } = this.props;
    if (id) {
      getNote(id);
      this.setState({ id });
    }
    if (info) {
      this.setState({
        info,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { visitNote } = nextProps;
    const { id } = this.state;
    if (visitNote[id]) {
      this.setState({ remoteInfo: visitNote[id] });
    }
  }

  render() {
    const { limits, simpleView, info: tagInfo } = this.props;
    const { remoteInfo } = this.state;

    let info = {};
    if (remoteInfo) {
      info = remoteInfo;
    }
    if (tagInfo) {
      info = tagInfo;
    }
    const alerts = getAlerts(info, limits);
    return info.visitNoteID ? (
      <div className="row visit-note-cell" ref={info.visitNoteID}>
        <div className="col-sm-8">
          <span className="review-label">Visit Note ID</span>
          <br />
          <strong>{info.visitNoteID}</strong>{' '}
          {info.signedBy === null && (
            <span className="label label-warning">
              <i className="fa fa-unlock" />
            </span>
          )}
          {info.signedBy !== null && (
            <span className="label label-success">
              <i className="fa fa-lock" />
            </span>
          )}
        </div>
        <div className="col-sm-4">
          <span className="review-label">Date</span>
          <br />
          <Moment date={info.dateOfService} format="MM/DD/YYYY" />
        </div>
        <div className="col-sm-8">
          <span className="review-label">Patient ID</span>
          <br />
          <a href={`https://www.app.elationemr.com/patient/${info.patientID}/`} target="_blank">{info.patientID}</a>
        </div>
        <div className="col-sm-4">
          <span className="review-label">Actions</span>
          <br />
          {info.isFollowUp && <span className="label label-info">F/U</span>}
          {info.isReviewed && (
            <span className="label label-default">Reviewed</span>
          )}
          {info.isResolved && (
            <span className="label label-success">Resolved</span>
          )}
          &nbsp;
        </div>
        {!simpleView && (
          <div className="col-sm-4">
            <span className="review-label">Visit Type</span>
            <br />
            {info.visitReason}
          </div>
        )}
        {!simpleView && (
          <div className="col-sm-4">
            <span className="review-label">Age</span>
            <br />
            {info.age}
          </div>
        )}
        {!simpleView && (
          <div className="col-sm-4">
            <span className="review-label">Gender</span>
            <br />
            {info.sex}
          </div>
        )}
        {!simpleView && (
          <div className="col-sm-12">
            <span className="review-label">Reason for Visit</span>
            <br />
            {info.reason}
          </div>
        )}
        {!simpleView && (
          <div className="col-sm-6 flags">
            <span className="review-label">Flags</span>
            <br />
            &nbsp;
            {info.mskFlag === 'Y' && info.mskFlag2 === 'yes' && (
              <span className="label label-danger">MSK</span>
            )}
            {info.mskFlag === 'Y' && info.mskFlag2 === 'maybe' && (
              <span className="label label-warning">MSK</span>
            )}
            {info.mskFlag === 'Y' && (info.mskFlag2 === 'no' || info.mskFlag2 === 'N/A') && (
              <span className="label" style={{ backgroundColor: '#000' }}>MSK</span>
            )}
            {info.mskFlag === 'N' && !!info.mskFlag2 && info.mskFlag2 !== 'N/A' && info.mskFlag2 !== 'no' && (
              <span className="label label-default">MSK</span>
            )}
            {info.diabetesFlag === '1' && (
              <span className="label label-danger">Diabetes</span>
            )}
          </div>
        )}
        {!simpleView && (
          <div className="col-sm-6 alerts">
            <span className="review-label">Alerts</span>
            <br />
            <PatientAlerts alerts={alerts} />
          </div>
        )}
        {!simpleView && (
          <div className="col-sm-12">
            <span className="review-label">DX Code(s)</span>
            <br />
            <ul className="dx-codes-list">
              {info.ICD1Description && <li>{info.ICD1Description}</li>}
              {info.ICD2Description && <li>{info.ICD2Description}</li>}
              {info.ICD3Description && <li>{info.ICD3Description}</li>}
              {info.ICD4Description && <li>{info.ICD4Description}</li>}
            </ul>
          </div>
        )}
        <div className="col-sm-12 text-right">
          <span className="review-label">Signed by</span>
          <br />
          {info.signedBy}
        </div>
      </div>
    ) : (
      <div className="spinner"></div>
    );
  }
}

export default connect(
  state => ({
    visitNote: state.visitNotes.visitNote
  }),
  dispatch => ({
    getNote: id => dispatch(requestVisitNote(id)),
  }),
  null,
  { withRef: true }
)(VisitNoteCard);



// WEBPACK FOOTER //
// ./src/routes/management/components/VisitNoteCard.js